<template>
  <div class="wid-1200 more-list">
    <!--面包屑-->
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item v-for="item in $route.params.breadcrumb.split('>')" :key="item">{{item }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="list-top">
      <span class="sort" @click="sort">
        排序：
        <span class="order"
          >发表时间
          <i class="el-icon-bottom" v-if="desc"></i>
          <i class="el-icon-top" v-else></i>
        </span>
      </span>
      <span class="total">共{{ total }}条</span>
    </div>
    <el-table :show-overflow-tooltip="true" :data="list" style="width: 100%" v-loading="loading">
      <el-table-column header-align="center" label="篇名">
        <template slot-scope="scope"
          ><a
            :href="scope.row.nodeUrl"
            target="_blank"
          >{{ scope.row.title }}</a
        ></template>
      </el-table-column>
      <el-table-column align="center" prop="author" label="作者">
      </el-table-column>
      <el-table-column align="center" prop="source" label="来源" width="150">
      </el-table-column>
      <el-table-column
        align="center"
        prop="pubDate"
        label="发表时间"
        width="100"
      >
      </el-table-column>
    </el-table>
        <div class="page">
          <el-pagination
            v-show="!loading && list.length"
            background
            :current-page.sync="pageIndex"
            hide-on-single-page
            layout="prev, pager, next"
            :total="total"
            @current-change="changePage"
          />
        </div>
  </div>
</template>
<script>
export default{
  data(){
    return{
      desc: true, // 默认降序
      loading: false,
      total: 0,
      list: [],
      pageIndex: 1
    }
  },
  mounted(){
    this.getList()
  },
  methods:{
    sort() {
      this.desc = !this.desc;
      this.getList();
    },
    getList(){
      this.loading = true
      let params = {
        uid: this.$route.params.uid,
        pageNum: this.pageIndex,
        pageSize: 10,
        sign: "更多",
        pubDateSort: this.desc ? "desc" : "asc"
      };
      this.axios
        .post("data/cnki/getKbaseList",params)
        .then((res) => {
          this.loading = false
          if (res.status == 200) {
            this.total = res.data.total;
            this.list = res.data.rows;
          } else {
            this.$message.error("获取失败！");
          }
        });
    },
    changePage(n) {
      this.pageIndex = n
      this.getList()
    }
  }
}
</script>
<style lang="scss" scoped>
.list-top {
  display: flex;
  justify-content: space-between;
  background: #fff5f5;
  border: 1px solid #fae0e0;
  height: 60px;
  line-height: 60px;
  font-size: 16px;
  padding: 0 20px;
  .sort {
    cursor: pointer;
  }
  .order {
    color: #de1c26;
  }
}
.page {
  text-align: center;
  margin: 20px 0;
  .el-pagination {
    display: inline-block;
    margin-bottom: 30px;
  }
}
</style>